import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isFormDirty: false,
    navigationDialog: {
        isOpen: false,
        targetPath: null,
        label: "You have unsaved changes. Do you want to leave?",
    }
};

const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
        setFormDirty: (state, action) => {
            state.isFormDirty = action.payload;
        },
        openNavigationDialog: (state, action) => {
            state.navigationDialog.isOpen = true;
            state.navigationDialog.targetPath = action.payload.targetPath;
            if (action.payload.label) {
                state.navigationDialog.label = action.payload.label;
            }
        },
        closeNavigationDialog: (state) => {
            state.navigationDialog.isOpen = false;
            state.navigationDialog.targetPath = null;
        }
    },
});

export const { setFormDirty, openNavigationDialog, closeNavigationDialog } = commonSlice.actions;
export const selectIsFormDirty = (state) => state.common.isFormDirty;
export const selectNavigationDialog = (state) => state.common.navigationDialog;

export default commonSlice.reducer;
